import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-card-experiencia-promocoes',
  templateUrl: './card-experiencia-promocoes.component.html',
  styleUrls: ['./card-experiencia-promocoes.component.scss'],
})
export class CardExperienciaPromocoesComponent {
  @Input() public idPromocaoUsuario: number = 0;
  @Input() public nomePromocao: string = '';
  @Input() public dataResgatePromocao: string = '';
  @Input() public dataValidadeResgatePromocao: string = '';
}